// extracted by mini-css-extract-plugin
export default {"summary":"summary--XyeFo form-group form-group_actions","changedAt":"changedAt--tdev0","hrDepartment":"hrDepartment--Hmdww","received":"received--i4IOJ","takenBy":"takenBy--aGBNx"};